import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateIntegrationSelectCompany = document.createElement('template');

templateIntegrationSelectCompany.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper" id="integrationSelectCompanyWrapper">
       <gz-title fontweight="500"  fontsize="14" id="select-company-title"></gz-title>
       <div id="select-company-dropdown">
            <gz-company-selector id="companySelectorDropdown" class="company-selector"></gz-company-selector>
       </div>
  </div>
`;
